export const categories = [
  {
    slug: 'jiqiao',
    name: '口交技巧',
    description: '从基础到进阶的口交技巧指南，帮助伴侣探索更多愉悦体验',
    icon: 'ri-heart-pulse-line',
  },
  {
    slug: 'anquan',
    name: '安全防护',
    description: '了解口交过程中的安全防护措施，降低性传播感染风险',
    icon: 'ri-shield-check-line',
  },
  {
    slug: 'weisheng',
    name: '卫生与健康',
    description: '口交前后的卫生注意事项，保持生殖健康与清洁',
    icon: 'ri-drop-line',
  },
  {
    slug: 'goutong',
    name: '沟通与心理',
    description: '如何与伴侣坦诚沟通，建立信任与舒适感，提升亲密关系质量',
    icon: 'ri-chat-heart-line',
  },
  {
    slug: 'xingjiankang',
    name: '性健康知识',
    description: '全面了解性健康知识，科学认识口交与整体健康的关系',
    icon: 'ri-mental-health-line',
  },
];

export const articles = [
  {
    slug: 'koujiao-jichu-ru-men-zhi-nan',
    title: '口交基础入门指南：从零开始的完整教程',
    category: 'jiqiao',
    summary: '本文为零基础读者提供全面的口交入门指导，涵盖基本的心理准备、体位选择、节奏控制和常见误区，帮助伴侣在舒适和尊重的前提下开启探索之旅。',
    content: [
      { type: 'h2', text: '前言' },
      { type: 'p', text: '口交是亲密关系中常见的性行为方式之一。对于初次尝试的伴侣来说，了解基本知识和技巧不仅能提升体验，更能确保双方在安全、舒适和互相尊重的情况下进行探索。本文将从零开始，为你提供全面、科学的口交入门指导。' },
      { type: 'h2', text: '心理准备：建立正确的认知' },
      { type: 'p', text: '在进行任何性行为之前，心理准备至关重要。口交并非"低人一等"的行为，而是伴侣间表达爱意和亲密的一种方式。双方都需要放下不必要的羞耻感或顾虑，以平等、尊重的态度面对这一体验。' },
      { type: 'p', text: '研究表明，积极开放的性态度与更高的性满意度和关系满意度密切相关。如果你或伴侣对口交存在心理障碍，建议先进行坦诚的沟通，了解彼此的想法和顾虑，而不是急于行动。' },
      { type: 'h2', text: '基础体位选择' },
      { type: 'p', text: '舒适的体位是良好体验的基础。以下是几种最常见且舒适的口交体位：' },
      { type: 'h3', text: '1. 接受方仰卧' },
      { type: 'p', text: '接受方平躺在床上或沙发上，双腿自然分开。给予方可以趴在接受方双腿之间，这个体位最大的优点是双方都能保持相对放松，适合初学者。接受方可以用枕头垫高臀部以获得更舒适的角度。' },
      { type: 'h3', text: '2. 给予方在下方' },
      { type: 'p', text: '接受方跨坐在给予方面部上方（俗称69式变体），这种体位让接受方拥有更多控制权，可以自主调节深度和节奏。对于初次尝试的接受方来说，这种体位能减少紧张感。' },
      { type: 'h3', text: '3. 侧卧体位' },
      { type: 'p', text: '双方面对面侧卧，给予方可以轻松触及接受方的生殖区域。这个体位强调亲密感和眼神交流，非常适合注重情感连接的伴侣。' },
      { type: 'h2', text: '节奏与力度控制' },
      { type: 'p', text: '口交的节奏和力度是影响体验的关键因素。以下是一些基本原则：' },
      { type: 'p', text: '开始时应以轻柔为主，使用舌尖轻轻触碰，观察伴侣的反应。随着双方逐渐进入状态，可以逐渐增加力度和速度。变化是关键——交替使用不同的节奏、力度和技巧可以维持兴奋感。' },
      { type: 'p', text: '特别注意：生殖器区域非常敏感，尤其是龟头（男性）和阴蒂（女性）。对这些区域的直接刺激应从极轻柔开始，根据伴侣的反馈逐渐调整。' },
      { type: 'h2', text: '常见误区与纠正' },
      { type: 'p', text: '误区一："越用力越好"——实际上，大多数人在口交中更偏好中等偏轻柔的刺激，过度的力度可能导致不适甚至疼痛。' },
      { type: 'p', text: '误区二："不需要沟通"——恰恰相反，口交中的沟通至关重要。使用安全词或手势可以在不破坏氛围的前提下传递信息。' },
      { type: 'p', text: '误区三："口交只是前戏"——对很多人来说，口交本身就是完整的性体验，不应将其仅仅视为"前戏"而轻视其重要性。' },
      { type: 'h2', text: '结语' },
      { type: 'p', text: '口交是一门需要学习和练习的技能，更是一种需要双方共同投入的亲密行为。保持耐心、互相尊重、持续沟通，你和伴侣一定能在这个过程中找到属于你们的最佳方式。' },
    ],
    readTime: '8分钟',
    imageSeq: 'article-basic-guide',
    imageQuery: 'Warm%20soft%20minimalist%20abstract%20background%20with%20gentle%20rose%20and%20cream%20tones%2C%20flowing%20organic%20shapes%2C%20elegant%20texture%2C%20mood%20of%20intimacy%20and%20trust%2C%20editorial%20quality%20with%20subtle%20gradients%2C%20calm%20serene%20atmosphere%2C%20no%20human%20figures%2C%20artistic%20abstract%20composition',
  },
  {
    slug: 'koujiao-jiqiao-gaoji-zhi-yin',
    title: '进阶口交技巧：提升双方快感的实用方法',
    category: 'jiqiao',
    summary: '已掌握基础技巧的伴侣可以通过本文学习进阶方法，包括节奏变化技巧、多区域刺激、呼吸配合以及如何识别伴侣的反应信号，进一步提升双方的口交体验。',
    content: [
      { type: 'h2', text: '从基础到进阶' },
      { type: 'p', text: '当你和伴侣已经熟练掌握基础口交技巧后，探索进阶方法可以为你们的亲密体验注入新的活力。进阶技巧的核心不在于"更复杂"，而在于"更精准"和"更默契"。' },
      { type: 'h2', text: '节奏变化的艺术' },
      { type: 'p', text: '进阶口交中，节奏控制远比单纯的"快慢"复杂。以下是一些实用的节奏变化方法：' },
      { type: 'p', text: '渐强渐弱法：从极轻柔开始，逐渐增加到中高强度，在接近高潮时突然放缓，重复2-3次再最终完成。这种边缘控制（Edging）技巧可以显著提升最终的快感强度。' },
      { type: 'p', text: '停顿技巧：在持续刺激中突然停顿3-5秒，然后以不同的方式重新开始。这种"意外"可以打破适应感，重新激发敏感度。' },
      { type: 'h2', text: '多区域同时刺激' },
      { type: 'p', text: '进阶体验的秘密在于不要只关注生殖器本身。手部同时刺激其他敏感区域可以产生1+1>2的效果。对于男性，可以同时轻抚会阴、大腿内侧或乳头区域；对于女性，配合G点或阴蒂的外部刺激常常带来更强烈的体验。' },
      { type: 'h2', text: '学会识别伴侣的反应' },
      { type: 'p', text: '每个人的快感表达方式不同。学会观察和识别伴侣的身体语言至关重要：呼吸变急促、身体不自觉的扭动、肌肉紧绷、发出声音等都可能表示刺激强度合适或接近高潮。反之，身体后缩、肌肉僵硬或突然安静可能是需要调整的信号。' },
      { type: 'h2', text: '温度与质感的探索' },
      { type: 'p', text: '适度的温度变化可以带来全新的刺激体验。在口交前含一口温水（注意温度不要过高）可以创造温暖湿润的感觉；而含一小块冰块（注意不要让冰块直接接触敏感区域）则可以产生清凉的对比刺激。务必在使用前与伴侣沟通并获得同意。' },
    ],
    readTime: '10分钟',
    imageSeq: 'article-advanced-skills',
    imageQuery: 'Elegant%20abstract%20composition%20with%20warm%20terracotta%20and%20cream%20gradients%2C%20flowing%20curves%20suggesting%20rhythm%20and%20harmony%2C%20soft%20lighting%20textures%2C%20artistic%20minimalist%20design%2C%20sophisticated%20editorial%20background%2C%20no%20figures%2C%20serene%20and%20intimate%20mood',
  },
  {
    slug: 'koujiao-yu-annquan-xing-chuan-bo-ji-bing-fang-hu',
    title: '口交与安全性行为：性传播疾病防护全攻略',
    category: 'anquan',
    summary: '口交同样存在性传播感染风险。本文详细介绍口交相关的STI风险、安全套和口腔保护膜的规范使用、疫苗接种建议以及定期检测的重要性。',
    content: [
      { type: 'h2', text: '口交同样存在感染风险' },
      { type: 'p', text: '一个常见的误解是"口交不会传播性病"。事实上，口交可以传播多种性传播感染（STI），包括但不限于：淋病、衣原体感染、梅毒、单纯疱疹病毒（HSV）、人乳头瘤病毒（HPV），以及在特定条件下HIV。了解并正视这些风险是负责任的性行为的第一步。' },
      { type: 'h2', text: '安全套的正确使用' },
      { type: 'p', text: '对于为男性口交（fellatio），使用安全套是最有效的防护方式。选择超薄或带有口味的专用安全套可以提升体验。使用时注意：检查有效期、小心撕开包装避免指甲划破、捏住储精囊排出空气后展开卷入。口交安全套同样遵循"一次性使用"原则，不可重复使用。' },
      { type: 'h2', text: '口腔保护膜的使用' },
      { type: 'p', text: '对于为女性口交（cunnilingus）和为肛门口交（anilingus），口腔保护膜（Dental Dam）提供了有效的防护。口腔保护膜是一块薄薄的乳胶或聚氨酯方块，覆盖在外阴或肛门区域，避免口腔与生殖器/肛门分泌物的直接接触。如果没有专业的口腔保护膜，可以临时将安全套剪开后展开使用。' },
      { type: 'h2', text: 'HPV疫苗接种' },
      { type: 'p', text: 'HPV是口交传播中最令人担忧的病毒之一，因为它与口咽癌的发生有明确关联。HPV疫苗（如九价疫苗）可以有效预防多种高危型HPV感染。推荐在性行为开始前接种，但对于已经有过性行为的人群，接种仍然具有保护价值。' },
      { type: 'h2', text: '定期检测的重要性' },
      { type: 'p', text: '即使采取了所有防护措施，定期进行性传播感染检测仍然至关重要。建议性活跃人群每6-12个月进行一次全面STI检测，如果有多位性伴侣或参与高风险行为，检测频率应增加至每3-6个月。许多STI在早期可能无症状，只有通过检测才能及时发现和治疗。' },
    ],
    readTime: '9分钟',
    imageSeq: 'article-safety-protection',
    imageQuery: 'Clean%20minimalist%20abstract%20background%20with%20soft%20cream%20and%20warm%20neutral%20tones%2C%20geometric%20shield-like%20shapes%20subtly%20integrated%2C%20professional%20medical-educational%20aesthetic%2C%20calm%20trustworthy%20atmosphere%2C%20no%20human%20figures%2C%20editorial%20quality%20with%20soft%20lighting',
  },
  {
    slug: 'koujiao-ganran-zheng-zhuang-zao-qi-shi-bie',
    title: '口交后感染症状：如何早期识别与应对',
    category: 'anquan',
    summary: '了解口交后可能出现的感染症状对于早期发现和治疗至关重要。本文系统介绍常见的警示信号、何时应就医以及治疗后的注意事项。',
    content: [
      { type: 'h2', text: '为什么早期识别很重要' },
      { type: 'p', text: '口交后如果出现感染，早期识别和及时治疗可以避免并发症，保护伴侣健康。许多STI在早期阶段治疗效果最好，且能显著降低传播风险。' },
      { type: 'h2', text: '口腔与咽喉的警示信号' },
      { type: 'p', text: '给予口交的一方需要特别关注口腔和咽喉的变化：持续超过一周的咽喉疼痛、口腔或咽喉出现溃疡或白斑、吞咽困难、持续的口腔异味、牙龈异常出血。这些症状可能提示淋病性咽炎、口腔疱疹或梅毒感染。' },
      { type: 'h2', text: '生殖区域的警示信号' },
      { type: 'p', text: '接受口交的一方需关注生殖区域的变化：异常分泌物（颜色、气味或量的改变）、生殖器或周围区域出现溃疡、水泡或疣状物、排尿时疼痛或灼热感、生殖区域瘙痒或刺激感。' },
      { type: 'h2', text: '何时应立即就医' },
      { type: 'p', text: '出现以下情况应立即就医：高热伴有生殖区域症状、剧烈疼痛影响日常生活、出现任何异常分泌物且伴有不适、怀疑暴露于HIV后72小时内（可考虑PEP暴露后预防）。即使症状轻微，如果持续超过一周也应就医检查。' },
    ],
    readTime: '7分钟',
    imageSeq: 'article-symptoms',
    imageQuery: 'Soft%20abstract%20medical-educational%20background%20with%20warm%20beige%20and%20cream%20tones%2C%20subtle%20geometric%20patterns%2C%20professional%20clinical%20aesthetic%20with%20human%20touch%2C%20calming%20trustworthy%20atmosphere%2C%20editorial%20quality%2C%20no%20human%20figures',
  },
  {
    slug: 'koujiao-qian-hou-wei-sheng-zhi-nan',
    title: '口交前后卫生指南：保持清洁与健康的关键步骤',
    category: 'weisheng',
    summary: '口交前后的卫生习惯对双方健康至关重要。本文提供详细的清洁步骤、应避免的行为以及日常生殖健康护理建议。',
    content: [
      { type: 'h2', text: '为什么口交卫生如此重要' },
      { type: 'p', text: '良好的卫生习惯不仅能减少感染风险，还能提升双方的舒适感和自信心。口腔和生殖器都拥有各自的微生物群落，在口交过程中这些菌群会相互接触，适当的卫生准备可以帮助实现更健康、更愉悦的体验。' },
      { type: 'h2', text: '口交前的卫生准备' },
      { type: 'h3', text: '给予方（口腔方）' },
      { type: 'p', text: '在口交前至少30分钟刷牙并使用牙线，这样可以清洁口腔但又有足够时间让可能因刷牙产生的微小伤口愈合。刷牙后使用不含酒精的漱口水。如果口腔内有伤口、溃疡或牙龈出血，建议使用口腔保护膜或在恢复后再进行口交。' },
      { type: 'h3', text: '接受方（生殖方）' },
      { type: 'p', text: '用温水和温和的无香料清洁产品清洗生殖区域。避免使用强力肥皂、香氛产品或灌洗液，这些产品会破坏生殖区域天然的pH平衡和有益菌群。特别注意清洗包皮下（男性）、阴唇褶皱（女性）和会阴区域。' },
      { type: 'h2', text: '口交后的卫生护理' },
      { type: 'p', text: '口交后再次用温水清洗生殖区域。给予方应漱口或再次刷牙。双方都应排空膀胱——这有助于冲洗可能进入尿道的细菌，降低尿路感染风险。' },
      { type: 'h2', text: '卫生误区澄清' },
      { type: 'p', text: '误区一："口交前必须彻底消毒"——生殖区域有正常的有益菌群，过度消毒会破坏平衡。温和清洁即可，无需使用消毒产品。' },
      { type: 'p', text: '误区二："口交后立即小便就够了"——排尿确实有帮助，但不能替代清洗。两者结合使用效果最好。' },
    ],
    readTime: '8分钟',
    imageSeq: 'article-hygiene',
    imageQuery: 'Clean%20minimalist%20spa-like%20abstract%20background%20with%20soft%20cream%20and%20pale%20rose%20tones%2C%20water-like%20flowing%20textures%2C%20fresh%20pure%20atmosphere%2C%20editorial%20quality%2C%20calm%20and%20serene%20mood%2C%20no%20human%20figures%2C%20elegant%20composition',
  },
  {
    slug: 'nan-xing-sheng-zhi-qi-wei-sheng-hu-li',
    title: '男性生殖器卫生护理：为口交做好准备的日常习惯',
    category: 'weisheng',
    summary: '男性生殖器的日常卫生护理对于口交体验和双方健康都有着重要影响。本文详细介绍正确的清洁方法、常见问题处理以及健康习惯培养。',
    content: [
      { type: 'h2', text: '日常清洁的重要性' },
      { type: 'p', text: '男性生殖器的清洁不仅关乎个人卫生，更直接影响伴侣的口交体验和健康。良好的日常清洁习惯可以有效减少异味、降低感染风险，并让双方在亲密时刻更加放松和投入。' },
      { type: 'h2', text: '正确的清洁方法' },
      { type: 'p', text: '每天用温水清洗生殖器区域，使用温和无香料的清洁产品。对于未割包皮的男性，需要轻轻将包皮推回，清洗龟头和包皮内侧的包皮垢（smegma）。清洗后用干净的毛巾轻轻拍干，保持干燥。过度清洗或使用强力产品反而会导致皮肤干燥和刺激。' },
      { type: 'h2', text: '常见问题与解决方案' },
      { type: 'p', text: '异味问题：通常源于包皮垢堆积或不彻底的清洁，改善清洁习惯通常可以解决。持续性异味可能需要就医排除感染。皮肤刺激：如果出现红疹或瘙痒，可能是清洁产品过敏或真菌感染，应咨询医生。' },
    ],
    readTime: '6分钟',
    imageSeq: 'article-male-hygiene',
    imageQuery: 'Minimalist%20abstract%20background%20with%20warm%20neutral%20beige%20and%20cream%20gradients%2C%20clean%20modern%20aesthetic%2C%20bathroom-spa%20inspired%20soft%20textures%2C%20editorial%20quality%2C%20professional%20yet%20warm%20atmosphere%2C%20no%20human%20figures',
  },
  {
    slug: 'yu-ban-lv-gou-tong-kou-jiao-xi-hao',
    title: '如何与伴侣沟通口交偏好：建立信任与舒适感',
    category: 'goutong',
    summary: '有效的沟通是提升口交体验的关键。本文提供具体的沟通策略，帮助伴侣在尊重和舒适的前提下坦诚交流各自的偏好、界限和期望。',
    content: [
      { type: 'h2', text: '为什么沟通如此重要' },
      { type: 'p', text: '每个人的身体反应、偏好和界限都是独特的。没有人能"读心"，也没有"放之四海皆准"的技巧。只有通过坦诚的沟通，伴侣才能真正了解彼此的需求，创造双方都满意的亲密体验。' },
      { type: 'h2', text: '选择合适的时机' },
      { type: 'p', text: '在亲密行为进行中讨论技巧可能会打断氛围。更好的做法是在非性情境下进行沟通：散步时、共进晚餐后、或在一个轻松舒适的午后。选择一个双方都放松、没有时间压力、不会被打扰的场合。' },
      { type: 'h2', text: '"三明治"沟通法' },
      { type: 'p', text: '当你需要提出调整建议时，使用"正面-建议-正面"的三明治结构可以有效避免伤害伴侣的自尊心。例如："我真的很喜欢你刚才那样做（正面），如果我们下次尝试稍微轻一点可能会感觉更好（建议），但我特别享受和你这样亲密的时刻（正面）。"' },
      { type: 'h2', text: '使用非语言信号' },
      { type: 'p', text: '在口交过程中，建立了非语言沟通系统可以让交流更加顺畅：轻拍伴侣的身体代表"轻一点"，手指的引导代表"往这里"，特定的手势可以代表"停一下"。提前约定好这些信号可以避免在过程中因为语言交流而中断氛围。' },
    ],
    readTime: '7分钟',
    imageSeq: 'article-communication',
    imageQuery: 'Warm%20intimate%20abstract%20background%20with%20soft%20rose%20and%20cream%20gradients%2C%20two%20flowing%20organic%20shapes%20intertwining%20harmoniously%2C%20gentle%20editorial%20aesthetic%2C%20mood%20of%20trust%20and%20closeness%2C%20no%20human%20figures%2C%20calm%20serene%20atmosphere',
  },
  {
    slug: 'koujiao-zhong-xin-li-zhang-ai-ke-fu',
    title: '口交中的心理障碍：如何克服焦虑与羞耻感',
    category: 'goutong',
    summary: '许多人在口交过程中会经历焦虑和羞耻感。本文从心理学角度分析这些情绪的成因，提供实用的克服策略，帮助建立更健康积极的性态度。',
    content: [
      { type: 'h2', text: '理解焦虑与羞耻的根源' },
      { type: 'p', text: '对口交感到焦虑或羞耻是人类常见的心理反应，这些情绪通常源于：社会文化中的性羞耻教育、对自身身体的不自信、对表现不够好的担忧、过往的负面体验、以及对未知的恐惧。理解这些情绪来自哪里是克服它们的第一步。' },
      { type: 'h2', text: '克服身体焦虑' },
      { type: 'p', text: '很多人担心自己的生殖器外观、气味或味道不够"好"。事实是：每个人的身体都是独特的，不存在"标准"或"完美"的生殖器。健康的生殖器有自然的气味和味道，这是正常的生理现象。如果对自己的身体感到不安，可以从低光环境开始，逐步建立自信，同时专注于当下的感觉而非自我评判。' },
      { type: 'h2', text: '正念练习在口交中的应用' },
      { type: 'p', text: '正念（Mindfulness）技巧可以显著减少性行为中的焦虑。在口交过程中，将注意力集中在当下的感官体验——嘴唇的触感、伴侣的温度、呼吸的节奏——而不是被"我做得够好吗"这样的想法带走。当自我评判的念头出现时，注意到它，然后温柔地将注意力带回当下的身体感受。' },
    ],
    readTime: '8分钟',
    imageSeq: 'article-psychology',
    imageQuery: 'Soft%20abstract%20background%20with%20gentle%20warm%20beige%20and%20cream%20gradients%2C%20calming%20atmospheric%20shapes%2C%20mindfulness-inspired%20composition%2C%20peaceful%20meditative%20aesthetic%2C%20editorial%20quality%2C%20no%20human%20figures%2C%20serene%20tranquil%20mood',
  },
  {
    slug: 'koujiao-yu-zheng-ti-xing-jian-kang',
    title: '口交与整体性健康：你需要知道的科学事实',
    category: 'xingjiankang',
    summary: '从科学角度了解口交与整体性健康的关系，包括生理影响、荷尔蒙变化、对亲密关系的积极效应以及常见健康问题的预防。',
    content: [
      { type: 'h2', text: '口交的生理益处' },
      { type: 'p', text: '从生理学角度看，口交和口交带来的性高潮对身体有多方面的积极影响。性高潮时释放的内啡肽和催产素可以缓解压力、改善情绪、促进睡眠。规律的性活动（包括口交）与降低血压、增强免疫功能有一定的相关性。' },
      { type: 'h2', text: '口交与关系满意度' },
      { type: 'p', text: '多项研究表明，性满意度与整体关系满意度密切相关。口交作为增加性多样性的方式之一，可以帮助维持长期关系中的性新鲜感。同时，口交过程中的互惠和关注伴侣感受的行为，强化了关系中的情感连接。' },
      { type: 'h2', text: '性别差异与科学认知' },
      { type: 'p', text: '研究发现，在异性恋关系中，女性接受口交的比例往往低于男性。了解这种差异背后的文化因素，倡导平等的性愉悦权，是现代性教育的重要组成部分。每个人的性偏好都应得到尊重，不应有性别方面的双重标准。' },
    ],
    readTime: '8分钟',
    imageSeq: 'article-health-science',
    imageQuery: 'Scientific%20educational%20abstract%20background%20with%20warm%20cream%20and%20soft%20earth%20tones%2C%20subtle%20molecular-wave%20patterns%2C%20professional%20medical%20aesthetic%20with%20human%20warmth%2C%20editorial%20quality%2C%20no%20human%20figures%2C%20calm%20trustworthy%20atmosphere',
  },
];

export const faqs = [
  {
    question: '口交会传播性病吗？',
    answer: '会的。口交可以传播多种性传播感染（STI），包括淋病、衣原体、梅毒、疱疹和HPV等。使用安全套（为男性口交时）或口腔保护膜（为女性或肛门口交时）可以显著降低感染风险。此外，保持良好卫生习惯和定期检测也是重要的防护措施。',
  },
  {
    question: '口交前需要做什么准备？',
    answer: '口交前的准备包括三个方面：卫生准备（双方清洗生殖器和口腔）、心理准备（确认双方自愿且舒适）、安全准备（根据需要准备安全套或口腔保护膜）。给予方建议在口交前30分钟刷牙，接受方用温水清洗生殖区域即可。',
  },
  {
    question: '口交有哪些健康益处？',
    answer: '口交作为性行为的一种形式，可能带来多种益处：性高潮释放的内啡肽有助于缓解压力和改善情绪；伴侣间的亲密互动可以增强情感连接和关系满意度；规律的性活动与更好的睡眠质量和免疫功能相关。当然，这些益处以安全、自愿和互相尊重为前提。',
  },
  {
    question: '如何让口交体验更好？',
    answer: '提升口交体验的关键在于：充分的前戏和润滑、开放坦诚的沟通、尊重双方节奏和界限、尝试不同的体位和技巧、专注于当下的感受而非"表现"。记住，好的体验来自双方的共同探索，而不是单方面的"技术"。',
  },
  {
    question: '口交后出现不适怎么办？',
    answer: '如果口交后出现口腔或生殖区域的不适，首先保持冷静。轻微的不适可能在1-2天内自行缓解。如果出现持续疼痛、异常分泌物、溃疡或发热等症状，应及时就医。就诊时诚实告知医生性行为史，这有助于准确诊断和治疗。',
  },
  {
    question: '口交中的安全词（Safe Word）如何使用？',
    answer: '安全词是预先约定的停止信号。可以选择一个与情境无关的词语（如"红色"代表立即停止，"黄色"代表需要调整）。如果口腔被占用无法说话，可以约定手势信号（如连续拍打伴侣身体三次）。安全词的使用需要双方都充分理解和尊重——一旦安全词发出，必须立即停止。',
  },
];

export const aboutContent = {
  brandName: '亲密指南',
  tagline: '以科学和尊重为基础，传播专业、可靠的性健康知识',
  introduction: '亲密指南是一个专注于性健康教育的知识平台。我们致力于以科学、专业和尊重的态度，为成年读者提供全面、准确的性健康知识，帮助人们在知情同意的前提下，提升亲密关系质量和性福体验。',
  mission: '我们的使命是打破性教育中的禁忌和误解，用科学和温暖的方式帮助每个人更好地了解自己的身体、尊重伴侣的界限、并享受健康积极的亲密生活。',
  values: [
    { title: '科学性', description: '所有内容基于循证医学研究和权威健康机构指南，确保信息的准确性和时效性。', icon: 'ri-microscope-line' },
    { title: '尊重包容', description: '我们尊重每个人的性取向、性别认同、文化背景和个人选择，不做道德评判。', icon: 'ri-heart-2-line' },
    { title: '隐私保护', description: '我们理解性健康话题的敏感性，绝不收集或分享任何可识别个人身份的信息。', icon: 'ri-lock-line' },
    { title: '负责任传播', description: '所有内容经专业人士审核，标注信息来源，清晰区分科学事实和个人建议。', icon: 'ri-shield-star-line' },
  ],
  contactEmail: 'contact@qinmizhinan.com',
  contactWechat: 'qinmizhinan_kf',
};